import { FileAttachment } from './attachments';

/** What Firebase stores at config/operatingCostCategories/{key} */
export interface OperatingCostCategoryData {
    label: string;
    sortOrder?: number;
}

/** Enriched type with the Firebase key included, used by consumers */
export interface OperatingCostCategory {
    key: string;
    label: string;
    sortOrder?: number;
}

export type IntervalUnit = 'month' | 'year';

export interface CostInterval {
    count: number;   // 1, 2, 3, etc.
    unit: IntervalUnit;
}

/** What Firebase stores at operatingCosts/{buildingKey}/{costKey} */
export interface OperatingCostData {
    categoryKey: string;
    amount: number;
    interval: CostInterval;
    description?: string;
    supplier?: string;
    attachments?: { [key: string]: FileAttachment };
    createdBy: string;       // UID
    createdAt: string;       // Stockholm timezone
    updatedBy?: string;      // UID
    updatedAt?: string;      // Stockholm timezone
}

/** Enriched type with the Firebase key included, used by consumers */
export interface OperatingCost extends OperatingCostData {
    key: string;
}

/** Helper to format interval as Swedish text */
export const formatInterval = (interval: CostInterval): string => {
    const { count, unit } = interval;
    if (unit === 'month') {
        if (count === 1) return 'per månad';
        if (count === 3) return 'per kvartal';
        if (count === 6) return 'per halvår';
        return `var ${count}:e månad`;
    } else {
        if (count === 1) return 'per år';
        return `var ${count}:e år`;
    }
};

/** Helper to calculate yearly cost from interval */
export const calculateYearlyCost = (amount: number, interval: CostInterval): number => {
    const { count, unit } = interval;
    if (unit === 'month') {
        return (amount * 12) / count;
    } else {
        return amount / count;
    }
};
